// extracted by mini-css-extract-plugin
export default {"root":"VirtualMachinesTableActions_root__KAEcO","action":"VirtualMachinesTableActions_action__ecTgE","linkAction":"VirtualMachinesTableActions_linkAction__LAK8T"};